export default {
     support: 'support',
     hero: 'hero'
}